<template>
  <BIconArrowClockwise animation="spin" />
</template>

<script>
import { BIconArrowClockwise } from 'bootstrap-vue'

export default {
  name: 'LoadingCell',
  components: { BIconArrowClockwise },
}
</script>

<style scoped></style>
